import { render, staticRenderFns } from "./WorkTypesTable.vue?vue&type=template&id=96619c10&scoped=true&"
import script from "./WorkTypesTable.vue?vue&type=script&lang=js&"
export * from "./WorkTypesTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkTypesTable.vue?vue&type=style&index=0&id=96619c10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96619c10",
  null
  
)

export default component.exports